function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "sib_logo_svg__radial-gradient",
  cx: 580.9,
  cy: 843,
  r: 53.7,
  gradientTransform: "matrix(-1 0 0 1 653 -791)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f69679"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ed1c24"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "sib_logo_svg__radial-gradient-2",
  cx: 1744.9,
  cy: 231,
  r: 53.7,
  gradientTransform: "matrix(1 0 0 -1 0 156)",
  xlinkHref: "#sib_logo_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("style", null, ".sib_logo_svg__cls-3{fill:url(#sib_logo_svg__radial-gradient-2)}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "sib_logo_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "sib_logo_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.3 0A14.3 14.3 0 000 14.3v124.3a14.3 14.3 0 0014.3 14.3h170.4a14.3 14.3 0 0014.3-14.3V14.3A14.3 14.3 0 00184.7 0H14.3z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.6 51.7a9.4 9.4 0 017.1-8.8l5.7-35.7H14.3a7.1 7.1 0 00-7.1 7.1v59.5zM28 28.9h7.9V21H43v7.9h7.9V36H43v7.9h-7.1V36H28z",
  fill: "url(#sib_logo_svg__radial-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  className: "sib_logo_svg__cls-3",
  d: "M164.4 113.7a4.2 4.2 0 002.4-2.1 5.2 5.2 0 00.7-2.5 4 4 0 00-2.1-3.9 16.5 16.5 0 00-6.3-1h-6.3v10h7.1a16.4 16.4 0 004.5-.5zm2.6 7.4c-1.4-.9-3.4-1.3-6.1-1.3h-8.1V131h8.4c5.3 0 7.9-1.9 7.9-5.7a4.5 4.5 0 00-2.1-4.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sib_logo_svg__cls-3",
  d: "M184.7 7.2H83.3l-5.9 36.9a9.5 9.5 0 014.3 8v.5l44.9 23.2a9.4 9.4 0 015.9-2.1 9.6 9.6 0 11-9.6 9.6v-.6L78.1 59.5a9.5 9.5 0 01-6 2.1 9.6 9.6 0 01-6.7-2.7L7.1 82.2v56.4a7.1 7.1 0 007.1 7.1h170.4a7.1 7.1 0 007.1-7.1V14.3a7 7 0 00-6.9-7.1zm-64.8 124.4a12 12 0 01-5.3 4.3 20.3 20.3 0 01-8.2 1.6 19 19 0 01-9.4-2.1 13 13 0 01-4.3-4.1 9.2 9.2 0 01-1.6-5 3.42 3.42 0 013.5-3.4 3.2 3.2 0 012.1.8 5.8 5.8 0 011.5 2.3 18 18 0 001.6 3.1 6.8 6.8 0 002.4 2 9.3 9.3 0 004.1.8 8.9 8.9 0 005.6-1.6 5 5 0 002.2-4 4.1 4.1 0 00-1.2-3.1 7.5 7.5 0 00-3-1.8 41.3 41.3 0 00-4.9-1.3 29.2 29.2 0 01-6.9-2.3 11 11 0 01-4.4-3.5 9.3 9.3 0 01-1.6-5.6 9.8 9.8 0 011.7-5.6 11.5 11.5 0 015-3.8 20.4 20.4 0 017.7-1.3 18.3 18.3 0 016.1.9 14.5 14.5 0 014.3 2.3 10 10 0 012.5 3.1 7.5 7.5 0 01.8 3.1 3.5 3.5 0 01-1 2.5 3.4 3.4 0 01-2.5 1.1 2.4 2.4 0 01-2-.7 7 7 0 01-1.5-2.2 9.1 9.1 0 00-2.5-3.4 7.6 7.6 0 00-4.7-1.2 8.3 8.3 0 00-4.9 1.3 3.8 3.8 0 00-1.8 3.2 3.4 3.4 0 00.6 2 4.7 4.7 0 001.7 1.4 10.2 10.2 0 002.2.9l3.7 1a60.7 60.7 0 015.9 1.7 18.9 18.9 0 014.5 2.2 10.2 10.2 0 012.9 3.3 10.4 10.4 0 011 4.9 12.5 12.5 0 01-1.9 6.2zm16.5 1.1a5.3 5.3 0 01-1.1 3.6 3.7 3.7 0 01-2.9 1.2 3.6 3.6 0 01-2.8-1.2 5.2 5.2 0 01-1.1-3.5V102a4.9 4.9 0 011.1-3.5 3.5 3.5 0 012.8-1.2 3.9 3.9 0 012.9 1.2 5.3 5.3 0 011.1 3.6zm38.9-1a9.8 9.8 0 01-4.5 3.8 15.6 15.6 0 01-4 1 41 41 0 01-5.3.3h-11.8a5 5 0 01-3.6-1.1 5.3 5.3 0 01-1.1-3.6v-28.9a5.5 5.5 0 011.1-3.7 5 5 0 013.6-1.1h12.5a34.3 34.3 0 014.8.3 10.3 10.3 0 013.6 1.3 8 8 0 012.4 2.1 9 9 0 012.1 6c0 3.9-1.9 6.7-5.8 8.5 5.1 1.6 7.6 4.7 7.6 9.4a9.7 9.7 0 01-1.6 5.7z"
})));

function SvgSiblogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 199 152.9"
  }, props), _ref, _ref2);
}

export default "assets/sib.logo.86e10d6.svg";
export { SvgSiblogo as ReactComponent };